import styled from "styled-components";

export const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 24px;
`;

export const Link = styled.a`
  cursor: pointer;
  z-index: 999;
  text-decoration: none;
  color: #006bee;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 18px;
`;

export const TermsContainer = styled.div`
  padding: 24px 32px;
  padding-top: 0px;
`;

export const TermsTitle = styled.h4`
  color: #1b2852;
  font-family: Averta PE;
  font-style: normal;
  font-weight: normal;
  font-size: 34px;
  line-height: 42px;
  padding-left: 32px;
`;

export const TitleDescriptive = styled.h4`
  font-family: AvertaPE;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.15px;
  color: #1b2852;
`;

export const TextDescriptive = styled.h4`
  font-family: AvertaPE;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: #69769b;

  margin-top: 8px;
  width: 80%;
`;
